import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField, Grid } from '@material-ui/core';

class ProfielDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      displayName:"",
      email:"",
      lastLoginTime: "",
      schoolName: "",
    };
    autoBind(this);

    if (this.props.root.refs.userDataProfile) {
      let userDataProfileState = this.props.root.refs.userDataProfile.state;
      this.state.displayName = userDataProfileState.userInfo.display_name;
      this.state.email = userDataProfileState.userInfo.email;
      this.state.lastLoginTime = userDataProfileState.userInfo.last_login_time;
      this.state.schoolName = (Localization.strings.getLanguage() === "en"? userDataProfileState.schoolInfo.name_eng : userDataProfileState.schoolInfo.name);
    }
  }

  updateProfile() {
    if (this.validateInput() == true) {
      let requestObj = {
        table: "user",
        where_field: "id",
        where_value: this.props.root.getMyUserId(),
        row: {
          display_name: this.state.displayName,
          email: this.state.email,
        }
      };
      this.props.root.refs.API.request("update", requestObj, this.updateProfileOK, this.updateProfileFail);
    }
  }

  updateProfileOK(res) {
    console.log("update profile ok");
    this.handleClose();
    this.props.root.addNotification(Localization.strings.UPDATED, true);
  }

  updateProfileFail(err) {
    console.log("update profile fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, false);
  }

  handleClose() {
    this.setState({
      open: false
    });
    this.state.open = false;
  }

  displayNameChanged(event) {
    this.setState({
      displayName: event.target.value
    });
    this.state.displayName = event.target.value;
  }

  emailChanged(event) {
    this.setState({
      email: event.target.value
    });
    this.state.email = event.target.value;
  }

  validateInput() {
    let result = true;
    let requirement = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = this.state.email.trim();
    let emailOK = (email.length > 0? requirement.test(email) : true);

    if (this.state.displayName.trim() == "") {
      result = false;
      this.props.root.addNotification(Localization.strings.DISPLAY_NAME_BLANK_REMINDER, false);
    }
    else if (!emailOK) {
      result = false;
      this.props.root.addNotification(Localization.strings.EMAIL_INCORRECT_REMINDER, false);
    }
    return result;
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle>{Localization.strings.USER_INFORMATION}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                {Localization.strings.SCHOOL_NAME}
              </Grid>
              <Grid item xs={12} sm={8}>
                {this.state.schoolName}
              </Grid>
              <Grid item xs={12} sm={4}>
                {Localization.strings.LAST_LOGIN_TIME}
              </Grid>
              <Grid item xs={12} sm={8}>
                {this.state.lastLoginTime}
              </Grid>
              <Grid item xs={12} sm={4}>
                {Localization.strings.DISPLAY_NAME}
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField style={{top:"10px"}}
                  margin="normal"
                  size="small"
                  variant="outlined"
                  value={this.state.displayName}
                  helperText={Localization.strings.DISPLAY_NAME_FOR_LOCALE}
                  onChange={this.displayNameChanged}
                >
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                {Localization.strings.EMAIL}
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField style={{top:"10px"}}
                  margin="normal"
                  size="small"
                  variant="outlined"
                  value={this.state.email}
                  helperText={Localization.strings.EMAIL_CAN_BE_USED_AS_LOGIN}
                  onChange={this.emailChanged}
                >
                </TextField>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button color="" onClick={this.handleClose} variant="contained">
              {Localization.strings.CANCEL}
            </Button>
            <Button color="primary" onClick={this.updateProfile} variant="contained">
              {Localization.strings.UPDATE_PROFILE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ProfielDialog;
